export const FETCH_FILTERS = 'app/core/shoplist/FETCH_FILTERS';
export const FETCH_VENDORS = 'app/core/shoplist/FETCH_VENDORS';
export const FETCH_MORE_VENDORS = 'app/core/shoplist/FETCH_MORE_VENDORS';
